import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'nest-radio',
  styleUrl: 'nest-radio.scss',
  shadow: true,
})
export class NestRadio {
  render() {
    return (
      <Host>
        Radio
      </Host>
    );
  }

}
